/**
 * Where overlays (Drawer, CommandPalette, More) mount. The AppShell provides its own root, which is a size container,
 * so an overlay lays out by the shell's width: a full screen inside a phone-width shell, a side sheet on a desk.
 */
import { createContext, useContext } from 'react'

export const PortalContext = createContext<HTMLElement | null>(null)
export const usePortal = () => useContext(PortalContext)
